import {Suspense, useContext, useEffect, useState} from 'react';
import {Route, Navigate} from 'react-router-dom';
import {Layout} from 'antd';
import {AppRoutes, LoginRoute, PrivateRoute} from 'utils/helpers/routeWrapper';
import {AuthContext} from 'context/Auth.context';
import Footer from 'components/layout/Footer';
import Header from 'components/layout/Header';
import FullScreenLoading from 'components/FullScreenLoading';
import Login from 'pages/UnionSide/Login';
import Register from 'pages/UnionSide/Register';
import Confirm from 'pages/UnionSide/Confirm';
import SERVICES from 'services';
import ForgotPassword from 'pages/UnionSide/ForgotPassword';
import ResetPassword from 'pages/UnionSide/ResetPassword';
import Payment from 'pages/UnionSide/Payment';
import Candidate from 'pages/CandidateSide/Candidate';
import {CandidateContext} from 'context/Candidate.context';
import {StudentContext} from 'context/Student.context';
import 'antd/dist/antd.less';
import 'antd/dist/antd.variable.min.css';
import './App.less';

const {Content} = Layout;

function App() {
	const [loading, setLoading] = useState(true);
	const [regIsOpen, setRegIsOpen] = useState(false);
	const {state: authState, dispatch: authDispatch} = useContext(AuthContext);
	const {dispatch: candidateDispatch} = useContext(CandidateContext);
	const {dispatch: studentDispatch} = useContext(StudentContext);

	const role = authState.student ? 'STUDENT' : 'CANDIDATE';

	useEffect(() => {
		if (authState.isAuthenticated) {
			SERVICES.USER.getProfile(role)
				.then(res => {
					if (role === 'CANDIDATE') {
						candidateDispatch({
							type: 'SET_PROFILE',
							payload: {
								name: res.data.name,
								lastname: res.data.lastname,
								middleName: res.data.middleName,
								id: res.data.id,
								telephone: res.data.telephone,
								email: res.data.email,
								path: res.data.path,
								status: res.data.status,
								statusID: res.data.statusID,
								registrationNumber: res.data.registrationNumber,
								curriculumPayment: res.data.curriculumPayment
							}
						});
					}
					if (role === 'STUDENT') {
						studentDispatch({
							type: 'SET_PROFILE',
							payload: {
								name: res.data.name,
								nameLatin: res.data.nameLatin,
								lastName: res.data.lastName,
								lastNameLatin: res.data.lastNameLatin,
								middleName: res.data.middleName,
								id: res.data.id,
								telephone: res.data.telephone,
								email: res.data.email,
								path: res.data.path,
								studentAccountingNumber: res.data.studentAccountingNumber,
								studentCode: res.data.studentCode,
								commands: res.data.commands?.data || [],
								courseID: res.data.courseID,
								courseName: res.data.courseName,
								currentStatusID: res.data.currentStatusID,
								currentStatusName: res.data.currentStatusName,
								facultyID: res.data.facultyID,
								facultyName: res.data.facultyName,
								flowID: res.data.flowID,
								flowName: res.data.flowName,
								optionalSubjects: res.data.optionalSubjects,
								studentLyon3Number: res.data.studentLyon3Number,
								imagePath:
									res.data.admissionFiles?.find((el: any) => el.typeID === 4)?.path ?? null,
								groupIDs: res.data.groupIDs,
								discount: res.data.dicsount,
								progressDiscount: res.data.progressDiscount,
								socialDiscount: res.data.socialDiscount,
								otherDiscount: res.data.otherDiscount,
								candidateID: res.data.candidateID
							}
						});
					}
				})
				.catch(e => {
					if (e.message === 'Candidate doesnt exist') {
						authDispatch({
							type: 'LOGOUT'
						});
					}
				})
				.finally(() => {
					setLoading(false);
				});
		} else {
			SERVICES.AUTH.checkAdmission()
				.then(() => {
					setRegIsOpen(true);
				})
				.catch(() => {
					setRegIsOpen(false);
				})
				.finally(() => {
					setLoading(false);
				});
		}
	}, [authState.isAuthenticated]);

	if (authState.isAuthenticated === undefined || loading) return <FullScreenLoading />;

	return (
		<Layout>
			<Header role={role} />
			<Suspense fallback={<FullScreenLoading />}>
				<Content>
					<AppRoutes
						regIsOpen={regIsOpen}
						isAuthenticated={!!authState.isAuthenticated}
						role={role}>
						<Route
							path="/login"
							element={
								<LoginRoute isAuthenticated={!!authState.isAuthenticated}>
									<Login regIsOpen={regIsOpen} />
								</LoginRoute>
							}
						/>
						{regIsOpen && (
							<Route
								path="/register"
								element={
									<LoginRoute isAuthenticated={!!authState.isAuthenticated}>
										<Register />
									</LoginRoute>
								}
							/>
						)}

						<Route
							path="/confirm"
							element={
								<LoginRoute isAuthenticated={!!authState.isAuthenticated}>
									<Confirm />
								</LoginRoute>
							}
						/>
						<Route
							path="/forgot_password"
							element={
								<LoginRoute isAuthenticated={!!authState.isAuthenticated}>
									<ForgotPassword />
								</LoginRoute>
							}
						/>
						<Route
							path="/reset_password"
							element={
								<LoginRoute isAuthenticated={!!authState.isAuthenticated}>
									<ResetPassword />
								</LoginRoute>
							}
						/>
						<Route
							path="/payment"
							element={
								<PrivateRoute isAuthenticated={!!authState.isAuthenticated}>
									<Payment success={true} />
								</PrivateRoute>
							}
						/>
						<Route
							path="/paymentError"
							element={
								<PrivateRoute isAuthenticated={!!authState.isAuthenticated}>
									<Payment success={false} />
								</PrivateRoute>
							}
						/>
						<Route path="/candidate" element={<Candidate />} />
						<Route
							path="*"
							element={
								<Navigate to={`${!!authState.isAuthenticated ? '/' : '/login'}`} replace />
							}
						/>
					</AppRoutes>
				</Content>
			</Suspense>
			<Footer />
		</Layout>
	);
}

export default App;
